import MasterSheetActions from "components/common/MasterSheetActions";
import { testMasterApi } from "api/testMaster";
import {
  SHEET_FILES,
  importFailures,
  importSkipped,
  importSummary,
} from "./testMasterSheet";

const TestMasterSheetActions = ({ searchText = "", onImported, disabled = false }) => {
  const search = String(searchText ?? "").trim();
  return (
    <MasterSheetActions
      api={testMasterApi}
      files={SHEET_FILES}
      exportParams={search ? { search } : {}}
      onImported={onImported}
      disabled={disabled}
      inputTestId="test-master-import-input"
      importSummary={importSummary}
      importFailures={importFailures}
      importSkipped={importSkipped}
    />
  );
};

export default TestMasterSheetActions;
